import type { TelemetryEvent } from '../../events';
import { isAnalyticsV2Event } from '../../events';

export const addUserAgentToAnalyticsV2Event = async (event: TelemetryEvent): Promise<TelemetryEvent> =>
  isAnalyticsV2Event(event)
    ? {
        ...event,
        properties: {
          ...event.properties,
          userAgent: navigator.userAgent,
        },
      }
    : event;
